import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { PatrimonioLiquidoService } from "../../patrimonio-liquido.service";
import { PatrimonioLiquido } from "src/app/model/patrimonio-liquido.model";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import moment from "moment";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NavigationEnd, Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ExportService } from "../../export.service";
import { ModalidadeService } from "src/app/shared/services/modalidade.service";
import { MODALIDADE_GARANTIA_FGBS, MODALIDADE_GARANTIA_PEAC_BS_EX } from "src/app/model/modalidade_garantia.model";

@Component({
    selector: 'app-patrimonio-liquido-pesquisa',
    templateUrl: './patrimonio-liquido-pesquisa.component.html',
    standalone: false
})
export class PatrimonioLiquidoPesquisaComponent implements OnInit, OnDestroy {
  atributosPaginacaoComponenteListagem: EntityPagedResult<PatrimonioLiquido>;
  opcoesPaginacao: number[];
  patrimonioLiquidos: PatrimonioLiquido[] = [];
  pesquisaForm: UntypedFormGroup;
  dataHoraResultado: string;
  msgSemResultado: boolean = false;
  podeCadastrar: boolean = false;
  private readonly destroy$ = new Subject();
  placeHolderDataBase = 'MM/AAAA';
  bnMaskDataBase = 'MESANO';
  modalidadePermiteDataBaseCompleta = false;

  constructor(
    private patrimonioLiquidoService: PatrimonioLiquidoService,
    private bnLoadingService: BnLoadingService,
    private permissaoService: PermissaoService,
    private exportService: ExportService,
    private el: ElementRef,
    private router: Router,
    private datePipe: DatePipe,
    formBuilder: UntypedFormBuilder,
    private modalidadeService: ModalidadeService
  ) {
    this.pesquisaForm = formBuilder.group({
      dataBase: null,
      dataRegistroInicial: null,
      dataRegistroFinal: null,
    });
  }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 15, 20];

    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: any) => {
        this.podeCadastrar = resp && resp[ROLE_GESTOR_ENVIO];
      });
    this.modalidadeService.modalidade$
      .pipe(takeUntil(this.destroy$))
      .subscribe(modalidade => {

        this.modalidadePermiteDataBaseCompleta = (modalidade === MODALIDADE_GARANTIA_FGBS || modalidade === MODALIDADE_GARANTIA_PEAC_BS_EX);
        if (this.modalidadePermiteDataBaseCompleta) {
          this.placeHolderDataBase = 'DD/MM/AAAA';
          this.bnMaskDataBase = 'DATA';
        }
      });

    this.construirFormulario();
    this.mudouDeRota();
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  mudouDeRota() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.limpar();
      }
    });
  }

  private construirFormulario() {
    const valoresPesquisaForm = JSON?.parse(sessionStorage.getItem('valoresPesquisaPatrimonioLiquidoForm'));
    if (valoresPesquisaForm) {
      let dataBase = null;
      if (valoresPesquisaForm.dataBase) {
        if (this.modalidadePermiteDataBaseCompleta) {
          dataBase = this.datePipe.transform(valoresPesquisaForm.dataBase, 'ddMMyyyy');
        } else {
          dataBase = this.datePipe.transform(valoresPesquisaForm.dataBase, 'MMyyyy');
        }
      }
      this.pesquisaForm.setValue({
        dataBase,
        dataRegistroInicial: valoresPesquisaForm.dataRegistroInicial,
        dataRegistroFinal: valoresPesquisaForm.dataRegistroFinal,
      });
    }
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      sessionStorage.setItem('valoresPesquisaPatrimonioLiquidoForm', JSON.stringify(novosValores));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<PatrimonioLiquido>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(true);
  }

  async buscar(paginado: boolean) {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    dadosPreenchidos.pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
    dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    try {
      const response = await this.patrimonioLiquidoService.getPatrimoniosLiquidos(dadosPreenchidos).toPromise();

      this.patrimonioLiquidos = response ? response.resultados : null;
      this.atributosPaginacaoComponenteListagem.count = response ?
        response.totalRegistrosSemPaginacao : 0;
      this.msgSemResultado = (this.atributosPaginacaoComponenteListagem.count === 0) || false;
      this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');

    } catch (err) {
      console.log(err);
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

  limpar() {
    this.atributosPaginacaoComponenteListagem.page = 1;
    this.patrimonioLiquidos = [];
    this.msgSemResultado = false;
    this.pesquisaForm.reset();
    setTimeout(() => {
      this.removeNgInvalidInput('dataInicial');
      this.removeNgInvalidInput('dataFinal');
    }, 100);
  }

  removeNgInvalidInput(id: string) {
    const inputElement = this.el.nativeElement.querySelector(`#${id}`);
    inputElement?.classList?.remove('ng-invalid');
  }

  tratarInformacoesPreenchidas() {
    let dadosPreenchidos: any = {};
    const form = this.pesquisaForm.value;

    if (form.dataRegistroInicial) {
      dadosPreenchidos.dataRegistroInicial = this.datePipe.transform(form.dataRegistroInicial, 'yyyyMMdd');
    }
    if (form.dataRegistroFinal) {
      dadosPreenchidos.dataRegistroFinal = this.datePipe.transform(form.dataRegistroFinal, 'yyyyMMdd');
    }
    if (form.dataBase) {
      let dataBase = moment(form.dataBase).format('YYYY-MM-DD')
      if (!this.modalidadePermiteDataBaseCompleta) {
        dataBase = moment(form.dataBase).endOf('month').format('YYYY-MM-DD')
      }
      dadosPreenchidos.dataBase = this.datePipe.transform(dataBase, "yyyyMMdd");
    }
    return dadosPreenchidos;
  }

  async exportar(event) {
    this.bnLoadingService.bloqueiaTela();
    try {
      const dadosPreenchidos = this.tratarInformacoesPreenchidas();
      const resp = await this.patrimonioLiquidoService.getPatrimoniosLiquidos(dadosPreenchidos).toPromise();
      this.exportService.exportarListaPatrimoniosLiquidos(resp);
    } finally {
      this.bnLoadingService.liberaTela();
    }

  }
}
